module.exports = __webpack_public_path__ + "static/media/No Data.f8c7ea63.svg";